import script from "./InstructionOdooPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionOdooPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionOdooPage.vue?vue&type=style&index=0&id=981adfbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981adfbc"]])

export default __exports__